import { ContainerNoPadding } from '@/components/Container'

export const FilterSection = ({
  FilterWilayah,
  FilterYearPeriod,
  FilterEducationLevel,
  FilterStatus,
  ButtonApply,
  ButtonDownload,
}) => {
  return (
    <section className="border-b bg-white py-8" id="filter-section">
      <ContainerNoPadding>
        <div className="flex flex-col justify-between gap-4 px-4 md:flex-row md:px-0">
          <div className="flex flex-col gap-2 md:flex-row">
            {FilterWilayah}
            {FilterYearPeriod}
            {FilterEducationLevel}
            {FilterStatus ? <>{FilterStatus}</> : null}
            {ButtonApply ? <>{ButtonApply}</> : null}
          </div>
          {ButtonDownload ? (
            <div className="flex w-full justify-end md:w-[190px]">
              {ButtonDownload}
            </div>
          ) : null}
        </div>
      </ContainerNoPadding>
    </section>
  )
}
